<p-dialog
  [(visible)]="visible"
  [modal]="true"
  [draggable]="false"
  [resizable]="false"
  [closable]="!busy"
  [header]="'socialFeed.blockConfirmTitle' | transloco"
  styleClass="ig-block-dialog"
  [style]="{ width: 'min(440px, calc(100vw - 32px))' }"
>
  <p class="ig-block__question">
    {{ 'socialFeed.blockConfirmQuestion' | transloco: { name: targetName } }}
  </p>

  <p class="ig-block__effects-title">{{ 'socialFeed.blockEffectsTitle' | transloco }}</p>
  <ul class="ig-block__effects">
    <li>{{ 'socialFeed.blockEffect1' | transloco }}</li>
    <li>{{ 'socialFeed.blockEffect3' | transloco }}</li>
    <li>{{ 'socialFeed.blockEffect4' | transloco }}</li>
  </ul>

  <div class="ig-block__actions">
    <button type="button" class="ig-block__btn ig-block__btn--cancel" [disabled]="busy" (click)="cancel()">
      {{ 'common.buttons.cancel' | transloco }}
    </button>
    <button type="button" class="ig-block__btn ig-block__btn--confirm" [disabled]="busy" (click)="confirm()">
      <i *ngIf="busy" class="pi pi-spin pi-spinner"></i>
      <i *ngIf="!busy" class="pi pi-ban"></i>
      {{ 'socialFeed.blockUser' | transloco }}
    </button>
  </div>
</p-dialog>
